<template>
  <v-layout row justify-center>
      <v-card>
        <v-card-title class="headline">Are you sure to delete Company?</v-card-title>
        <v-card-text>We not recomend to delete Company. Better disable it. </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click="deleteComp">Delete</v-btn>
          <v-btn color="green darken-1" flat @click="complist">Cancel</v-btn>
        </v-card-actions>
      </v-card>
  </v-layout>
</template>

<script>
import CompService from '@/services/CompService'

export default {
  name: 'companydelete',
  data () {
    return {
      msg: '',
      dialog: false
    }
  },
  methods: {
    async deleteComp () {
      try {
        if (this.$store.state.companyid) {
          await CompService.delete(this.$store.state.companyid)
          await this.$router.push({
            name: 'company'
          })
        }
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async complist () {
      try {
        await this.$router.push({
          name: 'company'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
